// @ts-strict-ignore
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {SimSystemExtendedService, SimUtilityService} from "@services";
import {ScenarioRecording, ScenarioRecordingState} from "@models";

@Component({
	selector: "sim-recording-timer",
	templateUrl: "./recording-timer.component.html",
	styleUrls: ["./recording-timer.component.scss"],
	standalone: false,
})
export class RecordingTimerComponent implements OnInit, OnChanges, OnDestroy {
	@Input({required: true}) scenarioRecording: ScenarioRecording;
	@Input() showAbsoluteTimeOverride: boolean | null = null;

	public scenarioRecordingTime = 0;
	public offset = 0;

	public intervalHandler = null;

	constructor(private _simSystemService: SimSystemExtendedService) {}

	public ngOnInit() {
		this._simSystemService.getLocalTimeOffset().then((offset: number) => {
			this.offset = offset;

			this.updateScenarioRecordingTime();
		});

		this.intervalHandler = setInterval(() => {
			this.updateScenarioRecordingTime();
		}, 500);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["scenarioRecording"]) {
			this.updateScenarioRecordingTime();
		}
	}

	public ngOnDestroy(): void {
		clearInterval(this.intervalHandler);
	}

	private updateScenarioRecordingTime() {
		if (this.scenarioRecording?.state === ScenarioRecordingState.Recording && this.scenarioRecording?.recordingScenes?.length > 0) {
			const localTimestamp = new Date().getTime();
			const createdOnTimestamp = SimUtilityService.getRecordingStart(this.scenarioRecording).getTime() - this.offset;

			this.scenarioRecordingTime = localTimestamp - createdOnTimestamp;
		} else {
			this.scenarioRecordingTime = 0;
		}
	}
}
